import { Box, Flex, HStack } from '@chakra-ui/react'
import { StepsToTreatmentData } from 'components/sections/StepsToTreatment/stepsToTreatmentData'
import { Body1, Body2, H5, H6 } from 'components/typography'
import { FC } from 'react'

interface StepToTreatmentSlideProps extends StepsToTreatmentData {
  stepIndex: number
}

const StepToTreatmentSlide: FC<StepToTreatmentSlideProps> = ({ title, subtitle, description, stepIndex }) => {
  return (
    <Box
      p={{ base: 6, lg: 8 }}
      bg="cyan.90"
      borderRadius="40px"
      h="full"
      flexFlow="row wrap"
      mx="12px"
      color="magicmint"
    >
      <Flex mb={12}>
        <HStack spacing={4}>
          <Flex justifyContent="center" alignItems="center" h="48px" minW="48px" border="2px" borderRadius="full">
            <Body1>{stepIndex + 1}</Body1>
          </Flex>
          {subtitle && <Body2>{subtitle}</Body2>}
        </HStack>

        {title && (
          <Box ml="1rem" my="auto">
            <H6>{title}</H6>
          </Box>
        )}
      </Flex>
      <H5>{description}</H5>
    </Box>
  )
}

export default StepToTreatmentSlide
